import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import styles from './AppModal.module.scss';
import classes from 'classnames';
import { Transition } from 'react-transition-group';

export interface AppModalProps {
  show?: boolean;
  type?:
    | 'fade'
    | 'slide-vertical-bottom'
    | 'slide-vertical-top'
    | 'slide-horizontal-right'
    | 'slide-horizontal-left'
    | 'slide-horizontal-start'
    | 'slide-horizontal-end';
  className?: string;
  modalContentClassName?: string;
  children?: React.ReactNode;
  showBackdrop?: boolean;
  backdropClassName?: string;
  onBackdropClick?: () => void;
  blockBodyScroll?: boolean;
}

const isDrawerType = (type: AppModalProps['type']) =>
  type === 'slide-horizontal-right' ||
  type === 'slide-horizontal-left' ||
  type === 'slide-horizontal-start' ||
  type === 'slide-horizontal-end';

const AppModal = ({
  show,
  type = 'fade',
  className,
  modalContentClassName,
  children,
  showBackdrop = true,
  backdropClassName,
  onBackdropClick,
  blockBodyScroll = false,
}: AppModalProps) => {
  const modalPortalElement = document.getElementById('modal_portal') as Element;
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <Transition in={show} timeout={400} mountOnEnter unmountOnExit nodeRef={nodeRef}>
      {(state: any) => {
        return ReactDOM.createPortal(
          <div
            ref={nodeRef}
            className={classes(styles.appModal, className, {
              [styles.blockBodyScroll]: blockBodyScroll,
            })}
          >
            {showBackdrop && (
              <div
                className={classes(
                  styles.backdrop,
                  styles[`backdrop-${state}`],
                  isDrawerType(type) ? styles.backdropDrawer : styles.backdropLight,
                  backdropClassName
                )}
                onClick={onBackdropClick}
              ></div>
            )}
            <div
              className={classes(
                styles.modalContent,
                styles[`${type}-${state}`],
                modalContentClassName
              )}
            >
              {children}
            </div>
          </div>,
          modalPortalElement
        );
      }}
    </Transition>
  );
};

export default AppModal;
